var render = function render(){var _vm=this,_c=_vm._self._c;return _c('commonSelect',{ref:"commonSelect",attrs:{"value":_vm.value,"placeholder":"请选择系统","clearable":_vm.clearable,"idKey":"SystemId","labelKey":"SystemName","get-data-func":_vm.getDataFunc},on:{"input":v=>_vm.$emit('input',v),"select":_vm.onSelect}})
}
var staticRenderFns = []

export { render, staticRenderFns }